import { IdUser, API } from "./apiConfig";
export const getSearchNumbers = (values) => {
  return API.post("/UnitCRM/CheckUserCRM", { ...values, IdUser });
};
export const getAddCustomer = (CustomerDetail) => {
  return API.post("/UnitCRM/CustomerRegistration", {
    ...CustomerDetail,
    IdUser,
  });
};
export const getActionComments = (IdActivityCrm) => {
  return API.post("/UnitCRM/CRM/ShowCommentForShowFile", {
    ...IdActivityCrm,
    IdUser,
  });
};
export const getCustomerData = (IdS0alesOpportunities) => {
  return API.post("/UnitCRM/ShowFileUser", {
    ...IdS0alesOpportunities,
    IdUser,
  });
};
export const getCrmData = (IdS0alesOpportunities) => {
  return API.post("/UnitCRM/ShowFileUser", {
    ...IdS0alesOpportunities,
    IdUser,
  });
};
export const getChangeResponsible = (changeresposible) => {
  return API.post("/UnitCRM/UpdateNewResponsible", {
    ...changeresposible,
    IdUser,
  });
};
export const getDeleteUserFile = (deleteuserdata) => {
  return API.post("/UnitCRM/DeleteFileUser", {
    ...deleteuserdata,
    IdUser,
  });
};
export const getOnlineInvoice = (OnlineInvoice) => {
  return API.post("/UnitCRM/CRM/ShowOrderOnline", {
    ...OnlineInvoice,
    IdUser,
  });
};
export const getNotDoneAction = (IdActivityCrm) => {
  return API.post("/UnitCRM/CRM/UpdateActivityToNotActive", {
    ...IdActivityCrm,
    IdUser,
  });
};
export const changeStatusLeaveRequest = (data) => {
  return API.post(
    "/UnitManagement/Employee/LeaveRequest/ChangeStatusLeaveRequest",
    {
      ...data,
      IdUser,
    }
  );
};
export const getOfflineInvoice = (OfflineInvoice) => {
  return API.post("/UnitCRM/CRM/ShowOrderOffline", {
    ...OfflineInvoice,
    IdUser,
  });
};
export const getEditCustomer = (EditedData) => {
  return API.post("/UnitCRM/CRM/UpdateFileUser", {
    ...EditedData,
    IdUser,
  });
};
export const getAddNewAddress = (Address) => {
  return API.post("/UnitCRM/CRM/NewAddressForCRM", {
    ...Address,
    IdUser,
  });
};
export const getAddAction = (action) => {
  return API.post("/UnitCRM/CRM/InsertActiviteCrm", {
    ...action,
    IdUser,
  });
};
export const getDeleteAction = (activityid) => {
  return API.post("/UnitCRM/CRM/DeleteActivityCrmFile", {
    ...activityid,
    IdUser,
  });
};
export const getSwitchAction = (activityid) => {
  return API.post("/UnitCRM/CRM/UpdateStatusImportantActivityCrmFile", {
    ...activityid,
    IdUser,
  });
};
export const getActionsDelayed = (activityid) => {
  return API.post("/UnitCRM/CRM/ShowDelayActivityCrm", {
    ...activityid,
    IdUser,
  });
};
export const getEditActivity = (editedData) => {
  return API.post("/UnitCRM/CRM/UpdateCRMActivity", {
    ...editedData,
    IdUser,
  });
};
export const getDelayAction = (delayData) => {
  return API.post("/UnitCRM/CRM/InsertDelayActivityCrm", {
    ...delayData,
    IdUser,
  });
};
export const getRestoreCustomer = (Id) => {
  return API.post("/UnitCRM/CRM/UpdateRestoreFile", {
    ...Id,
    IdUser,
  });
};
export const getAddComment = (comment) => {
  return API.post("/UnitCRM/CRM/InsertCommentForShowFile", {
    ...comment,
    IdUser,
  });
};
export const getHistoryList = (id) => {
  return API.post("/UnitCRM/CRM/ShowHistoryFile", {
    ...id,
    IdUser,
  });
};
export const getChangeOfflineInvoiceTag = (tagData) => {
  return API.post("/UnitCRM/CRM/UpdateTagFactorCrm", {
    ...tagData,
    IdUser,
  });
};
export const getChangeOfflineInvoiceResponsible = (responsibleData) => {
  return API.post("/UnitCRM/CRM/ChangeIdMarketerFactor", {
    ...responsibleData,
    IdUser,
  });
};
export const getChangeOfflineInvoiceStatus = (statusData) => {
  return API.post("/UnitCRM/CRM/ChangeUnsuccessfulFactor", {
    ...statusData,
    IdUser,
  });
};
export const getDeleteOfflineInvoice = (statusData) => {
  return API.post("/UnitCRM/CRM/ChangeUnsuccessfulFactor", {
    ...statusData,
    IdUser,
  });
};

export const getFilterCrmFile = (
  {
    IdResponsible,
    IdIdCities,
    RankingCustomer,
    methodOfIntroduction,
    KindCustomer,
    KindSeller,
    IdMarketer,
    ProbabilityOfPurchase,
    NameCategory,
    BrandCategory,
    Start,
    End,
  },
  PageNumber
) => {
  return API.post("/UnitCRM/CRM/SearchListFiles", {
    IdResponsible,
    IdIdCities,
    RankingCustomer,
    methodOfIntroduction,
    KindCustomer,
    KindSeller,
    IdMarketer,
    ProbabilityOfPurchase,
    NameCategory,
    BrandCategory,
    PageNumber,
    IdUser,
    Start,
    End,
  });
};
export const getAllActivities = (data) => {
  return API.post("/UnitCRM/CRM/CrmAllActivityList", {
    IdUser,
    ...data,
  });
};
export const getPassedActivities = (PageNumber) => {
  return API.post("/UnitCRM/CRM/CrmAllActivityListExpired", {
    PageNumber,
    IdUser,
  });
};
export const getClueWithoutActivity = () => {
  return API.post("/UnitCRM/CRM/ListNotActivityListClue", {
    IdUser,
  });
};
export const getTransactionsBasedOnUser = () => {
  return API.post("/UnitCRM/CRM/PersonListCurrentTradesOffline", {
    IdUser,
  });
};
export const getFilterTransactionsBasedOnUser = (data) => {
  return API.post("/UnitCRM/CRM/SearchPersonListCurrentTrades", {
    ...data,
    IdUser,
  });
};
export const getDeletedUsers = (PageNumber) => {
  return API.post("/UnitCRM/CRM/ListDeleteFiles", {
    PageNumber,
    IdUser,
  });
};
export const getCustomersWithoutActivity = () => {
  return API.post("/UnitCRM/CRM/ListNotActivityListCustomer", {
    IdUser,
  });
};
export const getQuickInvoice = (data) => {
  return API.post("/UnitCRM/CRM/InsertFactorUseCrmSpeed", {
    ...data,
    IdUser,
  });
};
export const getFilterMarker = (data) => {
  return API.post("/UnitCRM/CRM/SearchCrmMarker", {
    ...data,
    IdUser,
  });
};
export const getChangeActionsDate = (dates) => {
  return API.post("/UnitCRM/CRM/UpChangeDateInActivityList", {
    ...dates,
    IdUser,
  });
};
export const getDeleteActivity = (ids) => {
  return API.post("/UnitCRM/CRM/DeleteDateInActivityList", {
    ...ids,
    IdUser,
  });
};
export const getSearchUser = (search) => {
  return API.post("/UnitCRM/CRM/SearchUserFiles", {
    ...search,
    IdUser,
  });
};
export const getChangeOnlineInvoiceTag = (tagData) => {
  return API.post("/UnitCRM/CRM/UpdateTagFactorCrmOnline", {
    ...tagData,
    IdUser,
  });
};
export const getChangeOnlineInvoiceResponsible = (responsibleData) => {
  return API.post("/UnitCRM/CRM/ChangeIdMarketerFactorOnline", {
    ...responsibleData,
    IdUser,
  });
};
export const getNotes = (id) => {
  return API.post("/UnitCRM/CRM/ShowNoteForCrm", {
    ...id,
    IdUser,
  });
};
export const getAddNote = (data) => {
  return API.post("/UnitCRM/CRM/InsertNoteForCrm", {
    ...data,
    IdUser,
  });
};
export const getDeleteNote = (id) => {
  return API.post("/UnitCRM/CRM/DeleteNoteForCrm", {
    ...id,
    IdUser,
  });
};
export const getEditNote = (data) => {
  return API.post("/UnitCRM/CRM/UpdateNoteForCrm", {
    ...data,
    IdUser,
  });
};
export const getUsersList = () => {
  return API.post("/UnitCRM/CRM/ListFiles", {
    IdUser,
  });
};
export const getFirstFiles = () => {
  return API.post("/UnitCRM/CRM/ReferencesNewCustomer", {
    IdUser,
  });
};
export const getCrmDashboard = () => {
  return API.post("/UnitCRM/CRM/Dashboard", {
    IdUser,
  });
};
export const getChangeFirstFileResponsible = (data) => {
  return API.post("/UnitCRM/CRM/UpdateReferencesNewCustomer", {
    ...data,
    IdUser,
  });
};

export const getActivitiesDoneToday = () => {
  return API.post("/UnitCRM/CRM/CRMToDayActivityList", {
    IdUser,
  });
};
export const getActivitiesToday = () => {
  return API.post("/UnitCRM/CRM/CrmActivityList", {
    IdUser,
  });
};
export const getTradesList = (pageParam) => {
  return API.get(
    `/UnitCRM/CRM/ListCurrentTrades?IdUser=${IdUser}&PageNumber=${pageParam}`
  );
};
export const getTransactionFilter = (
  pageParam,
  FactorTag,
  IdMarketer,
  Start,
  End
) => {
  return API.get(
    `/UnitCRM/CRM/SearchListCurrentTrades?IdUser=${IdUser}&PageNumber=${pageParam}&FactorTag=${FactorTag}&IdMarketer=${IdMarketer}&Start=${Start}&End=${End}`
  );
};
export const getAreas = () => {
  return API.get("/UnitManagement/AllUser/ListAreas");
};
export const getCities = () => {
  return API.get("/UnitManagement/AllUser/ListProvincesAndCities");
};
export const getCat = () => {
  return API.get("/UnitManagement/AllUser/ListCategoriesLevelOne");
};
export const getBrands = () => {
  return API.get("/UnitManagement/AllUser/ListBrands");
};
export const getMarketer = () => {
  return API.get("/UnitManagement/AllUser/ListMarketer");
};
export const getCustomer = () => {
  return API.get("/UnitManagement/AllUser/ListColleague");
};
export const getInvoicelessCustomer = () => {
  return API.post("/UnitCRM/CRM/NoSellIsCompany", {
    IdUser: IdUser,
  });
};
export const getCrmMarkerData = () => {
  return API.post("/UnitCRM/CRM/CrmMarker", {
    IdUser,
  });
};
export const getUsersWithoutActivity = () => {
  return API.post("", {
    IdUser,
  });
};
export const getChatData = () => {
  return API.post("/UnitMessaging/OnlineChat/StartChatsList", {
    IdUser: IdUser,
  });
};
export const getChatBox = (id) => {
  return API.post("/UnitMessaging/OnlineChat/ChatsList", {
    ...id,
    IdUser,
  });
};
export const getCompanyUsers = () => {
  return API.get("/UnitManagement/AllUser/ManagersAndColleagues");
};
export const getReferChat = (data) => {
  return API.post("/UnitMessaging/OnlineChat/ReferralToAnother", {
    ...data,
    IdUser,
  });
};

export const getSupplierList = () => {
  return API.post("/UnitManagement/AllUser/ListSupplier", {
    IdUser: IdUser,
  });
};

export const getProvienceChart = (data) => {
  return API.post("/UnitCRM/Chart/ProvincialSalesChart", {
    IdUser: IdUser,
    ...data,
  });
};

export const getUnreadTicketsNumber = () => {
  return API.post("/UnitMessaging/Ticket/UnReadTicketCount", {
    IdUser: IdUser,
  });
};

export const getInsertTag = (data) => {
  return API.post("/UnitCRM/InsertTag", {
    ...data,
    IdUser,
  });
};

export const getShowTag = () => {
  return API.post("/UnitCRM/ShowTag", {
    IdUser: IdUser,
  });
};

export const getEditTag = (data) => {
  return API.post("/UnitCRM/UpdateTag", {
    ...data,
    IdUser,
  });
};

export const getGrouping = () => {
  return API.post("/UnitCRM/Grouping/ShowGroupingNewUserCrm", {
    IdUser,
  });
};

export const getInsertGrouping = (data) => {
  return API.post("/UnitCRM/Grouping/InsertGroupingNewUserCrm", {
    IdUser,
    ...data,
  });
};

export const getUpdateGroupingItem = (data) => {
  return API.post("/UnitCRM/Grouping/UpdateGroupingNewUserCrm", {
    IdUser,
    ...data,
  });
};

export const getUpdateGroupingItemStatus = (data) => {
  return API.post("/UnitCRM/Grouping/UpdateGroupingForActiveOrNotActive", {
    IdUser,
    ...data,
  });
};

export const getChangeStatusApp = (data) => {
  return API.post("/UnitCRM/UpdateStatusApplication", {
    IdUser,
    ...data,
  });
};

export const getGroupingData = () =>
  API.post("/UnitCRM/Grouping/ShowGroupingNewUserCrmForSelect", {
    IdUser,
  });

export const getEditOfflineInvoice = (data) =>
  API.post("/UnitCRM/UpdateOrderOfflineCrm", {
    IdUser,
    ...data,
  });

export const getEditOnlineInvoice = (data) =>
  API.post("/UnitCRM/UpdateOrderOnlineCrm", {
    IdUser,
    ...data,
  });

export const getChangeAllActionsType = (data) =>
  API.post("/UnitCRM/UpdateStatusImportantActivity", {
    IdUser,
    ...data,
  });

export const getMergeList = (data) =>
  API.post("/UnitCRM/CRM/ListMergeFile", data);

export const getDeleteMergeItem = (data) =>
  API.post("/UnitCRM/CRM/DeleteMergeFile", data);

export const addMergeItem = (data) =>
  API.post("/UnitCRM/CRM/InsertMergeFile", data);

export const updateMergeItem = (data) =>
  API.post("/UnitCRM/CRM/UpdateMergeFile", data);

export const getUrlList = () => API.post("/UnitCRM/CRM/ListUrlLog");

export const getUrlView = () =>
  API.post("/UnitCRM/Chart/ShowChartLog", { IdUser });

export const getInsertUrl = (data) => {
  API.post("/UnitCRM/CRM/InsertNewUrl", data);
};

export const getUpdateUrl = (data) => {
  API.post("/UnitCRM/CRM/UpdateUrlLog", {
    IdUser,
    ...data,
  });
};

export const getSellChart = (data) => {
  API.post("/UnitCRM/Chart/ShowChartListFiles", {
    IdUser,
    ...data,
  });
};

export const getAnswerAction = (data) => {
  API.post("/UnitCRM/UpdateAnswerCRMActivity", {
    IdUser,
    ...data,
  });
};
